import { StatusBar } from 'expo-status-bar';
import {  Image,  StyleSheet, Text, View, TouchableOpacity, ActivityIndicator, useWindowDimensions, Linking, FlatList, } from 'react-native';
import React, {useState, useEffect} from 'react';
import { Ionicons } from '@expo/vector-icons';
import formatRelative from './_lib/format';
import AsyncStorage from '@react-native-async-storage/async-storage';


export default function UserDetails({navigation, route}) {

    const { tokenKey } = route.params;
    const { email } = route.params;
    // const { Nume } = route.params;
    // const { preNume } = route.params;
    const { PUN_utilizatorID } = route.params;
    const { Diagnostic } = route.params;
    let [U_status, setU_Status] = useState('2');
    
    const windowHeight = useWindowDimensions().height;
    const [isLoading, setLoading] = useState(false);

    const [Nume, setNume] = useState();
    const [preNume, setpreNume] = useState();
    const [varsta, setVarsta] = useState('');
    const [ocupatia, setOcupatia] = useState('');
    const [mediu, setMediu] = useState();
    const [sex, setSex] = useState();
    const SearchIdUtilizator = async  () => {
      try {
      const response = await fetch('https://rupertapi.azurewebsites.net/api/utilizator/'+PUN_utilizatorID, {
          method:'GET',
          headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+tokenKey
          }
      }
      )
      const json = await response.json();
      console.log(json);
      setNume(json.nume);
      setpreNume(json.preNume);
      setVarsta(json.varsta);
      setOcupatia(json.ocupatia);
      // setSex(json.sex);
      if (json.sex === 1) {
        setSex('bărbat');
      } else
      if (json.sex === 2) {
        setSex('femeie');
      } else  {
        setSex('nedeterminat');
      }
      // setMediu(json.mediu);
      if (json.mediu === 1) {
        setMediu('urban');
      } else {
        setMediu('rural');
      }

      } catch (error) {
      console.error(error);

      } finally {

    }
  };

  let [post, setPost] = useState([]);
  const ActionSearch = async  () => {
    try {
      const response = await fetch('https://rupertapi.azurewebsites.net/api/afectiune/'+PUN_utilizatorID, {
        method:'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+tokenKey
        }
      }
      )
      const json = await response.json();
      console.log();
      setPost(json);

    } catch (error) {
      console.error(error);
      // setShouldShowCont(true);
      setPost([]);

      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const renderItem = ({ item }) => (
    <Text style={styles.panelbgr}>{item.dataInregistrarii} - {item.intrebari}</Text>
  );

  //Post to get Diagnostic from Actions for specific utilizator ID
  let [dlist, setDlist] = useState([]);
  const PostActionUtilizator = async  () => {
    try {
      const response = await fetch('https://rupertapi.azurewebsites.net/api/action', {
        method:'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+tokenKey
        },
        body: JSON.stringify(
          {
            "UtilizatorID": PUN_utilizatorID
          }
        )
      }
      )
      const json = await response.json();
      console.log(json);
      setDlist(json);
      // setLoading(false);
    } catch (error) {
      console.error(error);
      // setLoading(false);
    } finally {
      // setLoading(false);
    }
  };

  const formatDate = (raw_date) => {
    var date = new Date(raw_date);
    window.__localeId__ = 'ro'
    var formattedDate = formatRelative(date, new Date());
    return formattedDate;
  }

  //Diagnostic list 
  const renderDiagnostic = ({ item }) => (
    <View style={styles.panel}>
      <TouchableOpacity
        onPress={ () => {
          navigation.replace('Diagnostic',
          {
            tokenKey:tokenKey, 
            PUN_utilizatorID:PUN_utilizatorID,
            // currentDate: currentDate,
            sectiune: item.afectiuniSectiune,
            noPutActionUtilizator: true,
          });
          }
        }
      >
      <Text style={styles.panelbgr}>
      {formatDate(item.dataInregistrarii)} - <Text style={{fontWeight: "bold"}}>{item.diagnostic}</Text>
      </Text>
      </TouchableOpacity>
    </View>
  );


    // console.log('PUN_utilizatorID:'+PUN_utilizatorID);
    // console.log('token:'+tokenKey);
    // console.log('Nume:'+Nume);
    // console.log('email:'+email);
    // console.log('preNume:'+preNume);
    // console.log('Varsta:'+varsta);
    // console.log('Ocupatia:'+ocupatia);
    // console.log('Mediu:'+mediu);
    // console.log('Sex:'+sex);
    // console.log('Post:'+post);
    // console.log('Dlist:'+dlist);

    const storetokenKey = async (tokenKey) => {
      try {
        await AsyncStorage.setItem('@token', tokenKey);

      } catch (e) {
        console.log(e);
      }
    }



    const storePUN_utilizatorID = async (storePUN_utilizatorID) => {
      
      try {
        await AsyncStorage.setItem('@UtilizatorID', JSON.stringify(storePUN_utilizatorID));

      } catch (e) {
        console.log(e);
      }
    }
    const removetokenKey = async () => {
      try {
        await AsyncStorage.removeItem('@token');
      } catch(e) {
        console.log(e);
      }
      console.log('Logged out, @token removed');
      navigation.replace('Login',
      {
        tokenKey:tokenKey, 
      })
    }


    useEffect(() => {
      setLoading(true);
      storetokenKey(tokenKey);
      storePUN_utilizatorID(PUN_utilizatorID);
      PostActionUtilizator();
      SearchIdUtilizator();
      ActionSearch();
    }, []);
    return (
      isLoading ?
        <ActivityIndicator size="large" color="#628914" style={{top: 50, alignSelf: 'center', zIndex: 1, elevation: 1 }} />
      :
      <FlatList
        ListHeaderComponent={
            <View style={styles.container} >
            <View style={styles.row}>
              <Ionicons style={styles.h1icon} name="person-circle-outline" />
              <Text style={styles.h1}>{Nume} {preNume}, {sex}.</Text> 
            </View>
            <View style={styles.row}>
              <Ionicons style={styles.h2icon} name="file-tray-full" size={24} />
              <Text style={styles.h2}>Informatiile tale:</Text>
            </View>
            <Text style={styles.MainText1}>Vârsta: {varsta}</Text>
            <Text style={styles.MainText1}>Ocupația: {ocupatia}</Text>
            <Text style={styles.MainText1}>Mediul în care locuiești: {mediu}</Text>
            {/* <Ionicons style={styles.h2} name="list-circle" size={24} color="black" /> */}
            {/* <Text style={styles.h2}>Ai raspuns DA la urmatoarele intrebări:</Text> */}
            <View style={styles.row}>
              <Ionicons style={styles.h2icon} name="clipboard-sharp" size={24} />
              <Text style={styles.h2}>Posibil Diagnostic:</Text>
            </View>
            </View>
          }

        // data={post}
        // renderItem={renderItem}
        // keyExtractor={item => item.fisaID}

        data={dlist}
        renderItem={renderDiagnostic}
        keyExtractor={diag => diag.fisaID}

        ListFooterComponent={
          <View>   
          <TouchableOpacity 
              style={styles.AgainBtn} 
              onPress={() => {
                navigation.replace('Intrebari',
                  {
                    PUN_utilizatorID:PUN_utilizatorID,
                    PUN_U_Status:U_status,
                    tokenKey:tokenKey,
                    name:preNume
                  });
              }}
            >
                <Text style={{ color: "#fff" }}>Începe o nouă evaluare</Text>
            </TouchableOpacity>
            <TouchableOpacity 
              style={styles.ProgramBtn} 
              onPress={() => {
                Linking.openURL('https://psihomaestru.ro/terapie-individuala');
              }}
            >
                <Text style={{ color: "#fff" }}>Programeaza-te pentru o ședința</Text>
            </TouchableOpacity>
            <TouchableOpacity
            style={styles.logoutBtn}
            onPress={removetokenKey}
          >
            <View  style={{flexDirection:"row"}}>
              <View style={{justifyContent: 'flex-start',}}>
              <Text>Deloghează-te  </Text>
              </View>
              <View style={{justifyContent: 'flex-end',}}>
              <Ionicons name="log-out" size={24} color="black" />
              </View>
            </View>
          </TouchableOpacity>
            <StatusBar />
          </View>
        }

      />
    )
}

const styles = StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'center',
      backgroundColor: '#FFFFFF',
      width:"100%",
      height:"100%"
    },
    row: {
      flex: 1,
      flexDirection: "row"
    },
    h1icon: {
      fontSize: 34,
      alignContent: "flex-start",
      alignSelf: 'flex-start',
      left:10,
      padding:5,
      fontWeight: 'bold',
      color:"#628914",
      top:10,
    },
    h1: {
      fontSize: 20,
      alignContent: "flex-start",
      alignSelf: 'flex-start',
      left:20,
      padding:5,
      fontWeight: 'bold',
      color:"#628914",
      top:12,
    },
    h2icon: {
      fontSize: 18,
      alignContent: "flex-start",
      alignSelf: 'flex-start',
      left:20,
      color:"#628914",
      paddingTop:12,
      padding:5,
      fontWeight: 'bold',
    },
    h2: {
      fontSize: 18,
      alignContent: "flex-start",
      alignSelf: 'flex-start',
      left:20,
      color:"#628914",
      paddingTop:10,
      fontWeight: 'bold',
    },
    MainText: {
      fontSize: 16,
      alignContent: "flex-start",
      alignSelf: 'flex-start',
      color: "#3E473A",
      flexShrink: 1,
      padding:20,
      left:20,
      borderRadius: 10,
      backgroundColor: '#F2F2F2',
      padding:5
    },
    MainText1: {
      fontSize: 16,
      alignContent: "flex-start",
      alignSelf: 'flex-start',
      color: "#3E473A",
      flexShrink: 1,
      padding:5,
      left:20,
    },
    h3: {
      fontSize: 16,
      fontWeight: 'bold',
      color:"#6c1eb2",
    },
    AgainBtn: {
      backgroundColor: '#628914',
      alignSelf: 'center',
      width: 300,
      height: 50,
      borderRadius:20,
      justifyContent: 'center',
      alignItems: 'center',
      shadowColor: '#000',
      shadowOffset: {
        width:0,
        height:3,
      },
      top:10,
      marginBottom:20,

    },
    ProgramBtn: {
      backgroundColor: '#628914',
      alignSelf: 'center',
      width: 300,
      height: 50,
      borderRadius:20,
      justifyContent: 'center',
      alignItems: 'center',
      shadowColor: '#000',
      shadowOffset: {
        width:0,
        height:3,
      },
      marginBottom:30,
    },
    panel: {
      flex: 1,
      padding:2,
      shadowColor: '#000',
      width:'100%',
      borderRadius: 5,
    },
    panelbgr: {
      width: '100%',
      backgroundColor: '#CCD8A6',
      padding:10,
      borderRadius: 1,
      borderStyle: 'dotted',
      borderColor:'red',
    },
    logoutBtn: {
      alignSelf: 'flex-end',
      // width: 50,
      height: 50,
      right:20,
      justifyContent: 'center',
      alignItems: 'center',
    },
  });
   